import {css, getHoverColor, getActiveColor} from '../utils.js';

const styles = css`
    .tabbed-controls {
        display: flex;
        /* We are adding a bit of extra padding on the bottom 
        to adjust for _perceived_ whitespace. */
        /* We have reduced the padding at the top to ensure the collapse panel
        button and the tab controls are aligned. */
        padding: 12px 16px 24px 16px;
        flex-direction: column;
        gap: 16px;
    }

    .tab-navigation {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 16px;
    }

    .tab-navigation-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .tab-title {
        /* button reset */
        border-top: none;
        border-left: none;
        border-right: none;
        margin: 0;
        width: auto;
        overflow: visible;
        background: transparent;
        color: inherit;
        text-align: inherit;
        line-height: normal;
        -webkit-font-smoothing: inherit;
        -moz-osx-font-smoothing: inherit;
        -webkit-appearance: none;
        appearance: none;

        /* custom styles */
        display: flex;
        height: 36px;
        padding: 8px;
        justify-content: center;
        align-items: center;
        border-bottom: 2px solid transparent;
        /* The top border is just used to make the text vertically-centered when
        hovering/focusing the element. */
        border-top: 2px solid transparent;
        min-width: 50px;
    }

    .tab-title[disabled] {
        cursor: inherit;
    }

    .tab-title:not([disabled]):hover,
    .tab-title:not([disabled]):focus {
        background-color: ${({theme}) =>
            getHoverColor(
                theme.card_header_background_color,
                theme.color_scheme
            )};
    }
    .tab-title:not([disabled]):active {
        background-color: ${({theme}) =>
            getActiveColor(
                theme.card_header_background_color,
                theme.color_scheme
            )};
    }

    .tab-title.selected:not([disabled]) {
        border-bottom: 2px solid ${({theme}) => theme.button_border.color};
    }

    .tab-controls {
        display: grid;
        /* We use auto-fill here instead of auto-fit so we do not have
        ludicrously large inputs if there are only one or two inputs 
        but a very wide viewport. */
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 16px;
    }
`;

export default styles;
